export default "__VITE_ASSET__My0HO31K__"